import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalBody,
   ModalCloseButton,
   Box,
   Text,
   Table,
   Thead,
   Tbody,
   Tr,
   Th,
   Td,
   Badge,
   Code,
   VStack,
   HStack,
   Alert,
   AlertIcon,
   Button,
   useDisclosure,
   Grid,
   GridItem,
   Link,
   Icon,
   useToast,
   Spinner,
   FormControl,
   FormLabel,
   Input,
   ModalFooter,
} from '@chakra-ui/react';
import { InfoIcon, ExternalLinkIcon, RepeatIcon } from '@chakra-ui/icons';
import { addVoucher } from '../../../../redux/actions/voucher';
import { addPurchaseInvoice } from '../../../../redux/actions/purchaseInvoice';
import { addPurchaseReturnInvoice } from '../../../../redux/actions/purchaseReturnInvoice';
import { addSaleInvoice } from '../../../../redux/actions/salesInvoice';
import { addSaleReturnInvoice } from '../../../../redux/actions/salesReturnInvoice';
import { addAccount } from '../../../../redux/actions/account';
import { addItem } from '../../../../redux/actions/item';
import { addDaybook } from '../../../../redux/actions/daybook';
import { addBillTerm } from '../../../../redux/actions/billTerm';
import { addBank } from '../../../../redux/actions/bank';
import { addTransport } from '../../../../redux/actions/transport';
import { addDriver } from '../../../../redux/actions/driver';
import { addVehicle } from '../../../../redux/actions/vehicle';
import { addColor } from '../../../../redux/actions/color';
import { addStyle } from '../../../../redux/actions/style';
import { addSize } from '../../../../redux/actions/size';
import { addHsn } from '../../../../redux/actions/hsn';
import { addArea } from '../../../../redux/actions/area';
import { addSeries } from '../../../../redux/actions/series';
import { addBrand } from '../../../../redux/actions/brand';
import { getSingleLog, updateLogs } from '../../../../redux/actions/logs';
import { FaLock } from 'react-icons/fa6';
import { CopyIcon } from '@chakra-ui/icons';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { useUser } from 'contexts';
import { checkDocNo as salesCheckDocNo } from '../../../../redux/actions/salesInvoice';
import { checkDocNo as purchaseCheckDocNo } from '../../../../redux/actions/purchaseInvoice';
import { checkDocNo as salesReturnCheckDocNo } from '../../../../redux/actions/salesReturnInvoice';
import { checkDocNo as purchaseReturnCheckDocNo } from '../../../../redux/actions/purchaseReturnInvoice';
import { checkDocNo as issueCheckDocNo, addIssueInventory } from '../../../../redux/actions/issueInventory';
import { checkDocNo as receiveCheckDocNo, addReceiveInventory } from '../../../../redux/actions/receiveInventory';
import Swal from 'sweetalert2';
import { checkLastDocNumberVoucher } from '../../../../redux/actions/voucher';
import { ACCOUNT_FORM_FIELDS, DAYBOOK_FORM_FIELDS, ITEM_FORM_FIELDS, BANK_BRANCH_FORM_FIELDS, BILLTERM_FORM_FIELDS, TRANSPORT_FORM_FIELDS, DRIVER_FORM_FIELDS, VEHICLE_FORM_FIELDS, COLOR_FORM_FIELDS, STYLE_FORM_FIELDS, SIZE_FORM_FIELDS, AREA_FORM_FIELDS, BRAND_FORM_FIELDS } from "../../../../constants/formFields"
import { safeDate } from '../../../../utils/util';

// Import your API actions

const JsonDifferenceModal = ({ logData: initialLogData, isOpen, onClose }) => {
   // const accessCode = '';
   const { user } = useUser();
   const [logData, setLogData] = useState(initialLogData);
   const [isLoadingLogData, setIsLoadingLogData] = useState(false);
   const [tempAccessCode, setTempAccessCode] = useState('');
   const [accessCode, setAccessCode] = useState('');
   const { isOpen: isDeviceModalOpen, onOpen: onDeviceModalOpen, onClose: onDeviceModalClose } = useDisclosure();
   const {
      isOpen: isAccessCodeModalOpen,
      onOpen: onAccessCodeModalOpen,
      onClose: onAccessCodeModalClose,
   } = useDisclosure();
   const { isOpen: isOpenPayload, onOpen: onOpenPayload, onClose: onClosePayload } = useDisclosure();
   const [isRestoring, setIsRestoring] = useState(false);
   const dispatch = useDispatch();
   const toast = useToast();
   const financialYears = useSelector((state) => state?.dashboard?.financialYears);

   async function checkTransactionDocNo(transactionType, daybookId, docno, companyId) {
      const financialYear = financialYears.find((a) => a.financial_year === user?.financialYear);

      const data = {
         daybookId,
         docno,
         companyId,
         fromDate: moment(financialYear?.fy_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
         toDate: moment(financialYear?.fy_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      };
      if (transactionType === 'sales') {
         const res = await dispatch(salesCheckDocNo(data));
         return res;
      }

      if (transactionType === 'purchases') {
         const res = await dispatch(purchaseCheckDocNo(data));
         return res;
      }

      if (transactionType === 'purchasereturn') {
         const res = await dispatch(purchaseReturnCheckDocNo(data));
         return res;
      }

      if (transactionType === 'salesreturn') {
         const res = await dispatch(salesReturnCheckDocNo(data));
         return res;
      }

      if (transactionType === 'issue') {
         const res = await dispatch(issueCheckDocNo(data));
         return res;
      }

      if (transactionType === 'receive') {
         const res = await dispatch(receiveCheckDocNo(data));
         return res;
      }
      return null;
   }

   // Dynamic transaction data transformer function
   async function transformTransactionData(newJson, transactionType) {
      const baseHeader = {
         daybookId: newJson.daybookId || null,
         docno: newJson.docno || null,
         transactionAt: safeDate(newJson.transactionAt),
         companyId: newJson.companyId || null,
         accountId: newJson.accountId || null,
         brokerId: newJson.brokerId || null,
         basicAmount: newJson.basicAmount || 0,
         additionAmount: newJson.additionAmount || 0,
         deductionAmount: newJson.deductionAmount || 0,
         netAmount: newJson.netAmount || 0,
         dueDays: newJson.dueDays || 0,
         dueAt: safeDate(newJson.dueAt),
         billtoStateId: newJson.billtoStateId || null,
         shiptoStateId: newJson.shiptoStateId || null,
         warehouseId: newJson.warehouseId || null,
         notes: newJson.notes || null,
         representativeId: newJson.representativeId || null,
         voucherId: null,
         gstAmount: newJson.gstAmount || 0,
         taxableAmount: newJson.taxableAmount || 0,
         gstTxnType: newJson.gstTxnType || 0,
         gstSubTxnType: newJson.gstSubTxnType || 0,
         assesseType: newJson.assesseType || 0,
         distance: newJson.distance || 0,
      };
      const type = transactionType.toLowerCase();
      if (type === 'purchases' || type === 'purchasereturn' || type === 'issue' || type === 'receipt') {
         baseHeader.partyDate = safeDate(newJson.partyDate);
         baseHeader.partyNo = newJson.partyNo;
      }
      if (type === 'salesreturn') {
         baseHeader.originalBillDate = safeDate(newJson.originalBillDate);
         baseHeader.originalBillNo = newJson.originalBillNo;
      }
      // Transaction type specific header modifications
      const typeSpecificHeader = getTypeSpecificHeader(transactionType, newJson);
      const header = { ...baseHeader, ...typeSpecificHeader };
      if (type === 'salesreturn' || type === 'purchasereturn') {
         delete header.voucherId;
      }
      // Dynamic line items based on transaction type
      const lineItem = (newJson.lineitems || []).map((item, i) => {
         const baseLineItem = {
            typeOfSupply: item.typeOfSupply || null,
            itemId: item.itemId || null,
            lineNumber: i + 1,
            itemRate: item.itemRate || 0,
            amount: item.amount || 0,
            netAmount: item.netAmount || 0,
            ratePer: item.ratePer || 0,
            uomNoForRate: item.uomNoForRate || 0,
            qUnitId1: item.uomNoForRate || 160,
            qUnitId2: item.uomNoForRate || 160,
            qUnitId3: item.uomNoForRate || 160,
            qty1: item.qty1 || 0,
            qty2: item.qty2 || 0,
            qty3: item.qty3 || 0,
            addLess1Percent: item.addLess1Percent || 0,
            addLess1Amount: item.addLess1Amount || 0,
            addLess2Percent: item.addLess2Percent || 0,
            addLess2Amount: item.addLess2Amount || 0,
            addLess3Percent: item.addLess3Percent || 0,
            addLess3Amount: item.addLess3Amount || 0,
            taxableAmount: item.taxableAmount || 0,
            netGst: item.gstPercent || 0,
            gstPercent: item.gstPercent || 0,
            cgst: item.cgst || 0,
            sgst: item.sgst || 0,
            igst: item.igst || 0,
            issueLineId: null,
            hsnId: item.hsnId || null,
            sacId: item.sacId || null,
            subHSNId: null,
            takaDetails: [],
            warehouseId: item.warehouseId || null,
            isDeleted: false,
            gstWithRate: item.gstWithRate || 0,
         };

         // Add transaction-specific line item properties
         const typeSpecificLineItem = getTypeSpecificLineItem(transactionType, item);
         return { ...baseLineItem, ...typeSpecificLineItem };
      });

      if (type === 'salesreturn') {
         lineItem.map((item) => {
            if (item.stock && Array.isArray(item.stock)) {
               item.stock.map((stockItem) => {
                  delete stockItem.pinvLineDetailId;
                  return stockItem;
               });
            }
            return item;
         });
      }

      // Dynamic bill terms and payments based on transaction type
      const billTerms = getBillTerms(transactionType, newJson);
      if (Array.isArray(newJson.vouchers)) {
         newJson.vouchers.forEach((voucher) => {
            delete voucher.id;
            delete voucher.outAdjustmentId;
         });
      }
      const payments = newJson.vouchers; // getPayments(transactionType);
      // const payments = getPayments(transactionType, newJson);
      const additionalData = getAdditionalData(transactionType);

      const result = {
         header,
         lineItem,
         [getBillTermsKey(transactionType)]: billTerms,
         ...additionalData,
      };

      const exchanges = {
         exchange: [],
         payments: [],
      };

      if (['purchases', 'sales'].includes(transactionType.toLowerCase())) result.payments = payments;
      if (['sales'].includes(transactionType.toLowerCase())) {
         if (!newJson.exchange?.id) {
            result.exchange = exchanges;
         }
      }
      return result;
   }

   // Helper function to get transaction type specific header properties
   function getTypeSpecificHeader(transactionType, newJson) {
      const type = transactionType.toLowerCase();
      const safeDate = (d) => (d ? d.split('T')[0] : null);
      switch (type) {
         case 'purchases':
         case 'purchasereturn':
            return {
               // Purchase specific header fields (if any additional ones are needed)
            };

         case 'sales':
            return;
         case 'salesreturn':
            return;
         // return 'saleBillTerms';

         // case 'saleBillTerms':
         //    return {
         //       originalBillNo: newJson.originalBillNo || '',
         //       originalBillDate: newJson.originalBillDate ? safeDate(newJson.originalBillDate) : null,
         //    };

         case 'issue':
            return {
               // Issue specific header fields
               issueType: newJson.issueType || null,
               requestedBy: newJson.requestedBy || null,
            };

         case 'receipt':
            return {
               // Receipt specific header fields
               receiptType: newJson.receiptType || null,
               receivedFrom: newJson.receivedFrom || null,
            };

         default:
            return {};
      }
   }

   // Helper function to get transaction type specific line item properties
   function getTypeSpecificLineItem(transactionType, item) {
      const type = transactionType.toLowerCase();
      switch (type) {
         case 'purchases':
            return {
               stock: (item.purchaseLineDetail || []).map((stock) => ({
                  serialNo: stock.serialNo || '',
                  serialNo2: stock.serialNo2 || '',
                  barcode: stock.barcode || '',
                  note1: '',
                  isOld: stock.isOld || false,
                  itemId: stock.itemId || null,
                  itemName: stock.itemName || '',
                  warehouseId: item.warehouseId || null,
                  issueLineDetailId: item.issueLineDetailId || null,
               })),
            };
         case 'purchasereturn':
            return {
               stock: (item.purchaseLineDetail || item.purchaseReturnLineDetail || []).map((stock) => {
                  return {
                     serialNo: stock.serialNo || '',
                     serialNo2: stock.serialNo2 || '',
                     barcode: stock.barcode || '',
                     note1: '',
                     isOld: stock.isOld || false,
                     itemId: stock.itemId || null,
                     itemName: stock.itemName || '',
                     warehouseId: item.warehouseId || null,
                     salesReturnLineDetailId: stock.salesReturnLineDetailId || null,
                     purchaseLineDetailId: stock.purchaseLineDetailId || null,
                  }
               }),
            };

         case 'sales':
            return {
               stock: (item.salesLineDetail || []).map((stock) => ({
                  itemId: stock.itemId || null,
                  itemName: stock.itemName || '',
                  pcs: stock.pcs || stock.quantity1 || 1,
                  serialNo: stock.serialNo || '',
                  serialNo2: stock.serialNo2 || '',
                  barcode: stock.barcode || '',
                  isOld: stock.isOld || false,
                  pinvLineDetailId: stock.pinvLineDetailId || null,
                  salesReturnLineDetailId: stock.salesReturnLineDetailId || null,
                  warehouseId: stock.warehouseId || null,
               })),
            };
         case 'salesreturn':
            return {
               stock: (item.salesReturnLineDetail || item.salesLineDetail || []).map((stock) => ({
                  itemId: stock.itemId || null,
                  itemName: stock.itemName || '',
                  pcs: stock.pcs || stock.quantity1 || 1,
                  serialNo: stock.serialNo || '',
                  serialNo2: stock.serialNo2 || '',
                  barcode: stock.barcode || '',
                  isOld: stock.isOld || false,
                  salesLineDetailId: stock.salesLineDetailId || null,
                  warehouseId: stock.warehouseId || null,
               })),
               subHSNId: item.subHSNId || null,
            };

         case 'issue':
            return {
               stock: (item.issueLineDetail || []).map((stock) => ({
                  serialNo: stock.serialNo || '',
                  serialNo2: stock.serialNo2 || '',
                  barcode: stock.barcode || '',
                  note1: '',
                  isOld: stock.isOld || false,
                  itemId: stock.itemId || null,
                  itemName: stock.itemName || '',
                  warehouseId: item.warehouseId || null,
                  pinvLineDetailId: item.pinvLineDetailId || null,
                  receiveLineDetailId: item.receiveLineDetailId || null,
               })),
            };

         case 'receive':
            return {
               stock: (item.receiptLineDetail || []).map((stock) => ({
                  serialNo: stock.serialNo || '',
                  serialNo2: stock.serialNo2 || '',
                  barcode: stock.barcode || '',
                  note1: '',
                  isOld: stock.isOld || false,
                  itemId: stock.itemId || null,
                  itemName: stock.itemName || '',
                  warehouseId: item.warehouseId || null,
               })),
            };

         default:
            return {};
      }
   }

   // Helper function to get bill terms based on transaction type
   function getBillTerms(transactionType, newJson) {
      const type = transactionType.toLowerCase();

      switch (type) {
         case 'purchases':
         case 'purchasereturn':

         case 'sales':
         case 'salesreturn':
         // return newJson.salebillterms;
         // return [17, 18, 19, 20].map((id) => ({
         //    billTermId: id,
         //    percentage: 0,
         //    amount: 0,
         // }));

         case 'issue':
         case 'receipt':
            return []; // No bill terms for issue/receipt

         default:
            return [];
      }
   }

   // Helper function to get payments based on transaction type
   function getPayments(transactionType, newJson) {
      const type = transactionType.toLowerCase();

      switch (type) {
         case 'purchases':
            delete newJson.vouchers.id;
            delete newJson.vouchers.outAdjustmentId;
            return;
         case 'purchasereturn':
         case 'sales':
         case 'salesreturn':
         case 'issue':
         case 'receipt':
            return []; // No payments for issue/receipt

         default:
            return [];
      }
   }

   // Helper function to get additional data based on transaction type
   function getAdditionalData(transactionType) {
      const type = transactionType.toLowerCase();

      switch (type) {
         case 'sales':
         case 'salesreturn':

         case 'salesreturn2':
            break;

         default:
            return {};
      }
   }

   // Helper function to get the correct bill terms key based on transaction type
   function getBillTermsKey(transactionType) {
      const type = transactionType.toLowerCase();

      switch (type) {
         case 'purchases':
         case 'purchasereturn':
            return 'purchaseBillTerms';

         case 'sales':
         case 'salesreturn':
            return 'saleBillTerms';

         case 'issue':
            return 'issueBillTerms';

         case 'receive':
            return 'billTerm';

         default:
            return 'billTerms';
      }
   }

   const fetchDetailedLogData = async (codeToUse = accessCode) => {
      if (!initialLogData?.id) return;

      try {
         setIsLoadingLogData(true);
         const detailedLogData = await dispatch(getSingleLog(initialLogData.id, codeToUse));
         if (detailedLogData) {
            setLogData(detailedLogData);
            onOpenPayload();
            setTempAccessCode();
         }
      } catch (error) {
         console.error('Failed to fetch detailed log data:', error);
         toast({
            title: 'Error',
            description: 'Failed to load detailed log data. Please check your access code and try again.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      } finally {
         setIsLoadingLogData(false);
      }
   };

   const handleSetAccessCode = () => {
      setAccessCode(tempAccessCode);
      onAccessCodeModalClose();
      fetchDetailedLogData(tempAccessCode);
   };

   const handleAccessCodeModalOpen = () => {
      setTempAccessCode(accessCode);
      onAccessCodeModalOpen();
   };

   // Inside your component, add this:
   const scrollRef = useRef(null);
   // Fetch detailed log data when modal opens
   useEffect(() => {
      const fetchLogData = async () => {
         if (isOpen && initialLogData?.id && accessCode) {
            try {
               setIsLoadingLogData(true);
               const detailedLogData = await dispatch(getSingleLog(initialLogData.id, accessCode));
               if (detailedLogData) {
                  setLogData(detailedLogData);
                  onOpenPayload();
                  setTempAccessCode();
               }
            } catch (error) {
               console.error('Failed to fetch detailed log data:', error);
               toast({
                  title: 'Error',
                  description: 'Failed to load detailed log data. Please try again.',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
               });
            } finally {
               setIsLoadingLogData(false);
            }
         }
      };

      fetchLogData();
   }, [isOpen, initialLogData?.id, accessCode, dispatch, toast]);

   // Reset logData when modal closes
   useEffect(() => {
      if (!isOpen) {
         setLogData(initialLogData);
      }
   }, [isOpen, initialLogData]);

   useEffect(() => {
      if (isDeviceModalOpen && scrollRef.current) {
         const scrollElement = scrollRef.current;

         scrollElement.focus();

         const handleWheel = (e) => {
            e.preventDefault();
            e.stopPropagation();
            scrollElement.scrollTop += e.deltaY;
         };

         scrollElement.addEventListener('wheel', handleWheel, { passive: false });

         return () => {
            scrollElement.removeEventListener('wheel', handleWheel);
         };
      }
   }, [isDeviceModalOpen]);

   // API mapping based on table names
   const getAPIAction = async (tableName, logData) => {
      const table = tableName?.toLowerCase();

      // Handle transaction types that need transformation
      const transactionTypes = ['purchases', 'purchasereturn', 'sales', 'salesreturn', 'issue', 'receive'];

      if (transactionTypes.includes(table)) {
         const transformed = await transformTransactionData(logData, table);
         // Map to appropriate action
         const actionMap = {
            purchases: addPurchaseInvoice,
            purchasereturn: addPurchaseReturnInvoice,
            sales: addSaleInvoice,
            salesreturn: addSaleReturnInvoice,
            issue: addIssueInventory,
            receive: addReceiveInventory,
         };
         return {
            action: actionMap[table],
            payload: transformed,
         };
      }

      // Handle other table types (vouchers, etc.) - existing functionality
      const apiMap = {
         voucher: addVoucher,
         account: addAccount,
         item: addItem,
         daybook: addDaybook,
         billterm: addBillTerm,
         bankbranch: addBank,
         transport: addTransport,
         driver: addDriver,
         vehicle: addVehicle,
         color: addColor,
         style: addStyle,
         size: addSize,
         area: addArea,
         series: addSeries,
         brand: addBrand,
         hsnmain: addHsn,
         // Add other non-transaction mappings here
      };
      if (table === "account") {
         const payload = ACCOUNT_FORM_FIELDS.reduce((acc, field) => {
            if (field in logData) {
               acc[field] = logData[field];
            }
            return acc;
         }, {});

         const addressJson = logData?.accountaddress?.map((a) => ({
            name: a?.name,
            address1: a?.address1,
            address2: a?.address2,
            address3: a?.address3,
            gst: a?.gst,
            mobile: a?.mobile,
            email: a?.email,
            pincode: a?.pincode,
            areaId: a?.areaId,
            stateId: a?.stateId,
            coId: a?.coId,
            cityId: a?.cityId,
         }));
         return {
            action: apiMap[table],
            payload: {
               ...payload, addressJson: addressJson
            },
         };
      }
      if (table === "item") {
         const payload = ITEM_FORM_FIELDS.reduce((acc, field) => {
            if (field in logData) {
               acc[field] = logData[field];
            }
            return acc;
         }, {});
         return {
            action: apiMap[table],
            payload: payload,
         };
      }
      if (table === "daybook") {
         const payload = DAYBOOK_FORM_FIELDS.reduce((acc, field) => {
            if (field in logData) {
               acc[field] = logData[field];
            }
            return acc;
         }, {});
         return {
            action: apiMap[table],
            payload: payload,
         };
      }
      if (table === "billterm") {
         const payload = BILLTERM_FORM_FIELDS.reduce((acc, field) => {
            if (field in logData) {
               acc[field] = logData[field];
            }
            return acc;
         }, {});
         return {
            action: apiMap[table],
            payload: payload,
         };
      }
      if (table === "bankbranch") {
         const payload = BANK_BRANCH_FORM_FIELDS.reduce((acc, field) => {
            if (field in logData) {
               acc[field] = logData[field];
            }
            return acc;
         }, {});
         return {
            action: apiMap[table],
            payload: payload,
         };
      }
      if (table === "transport") {
         const payload = TRANSPORT_FORM_FIELDS.reduce((acc, field) => {
            if (field in logData) {
               acc[field] = logData[field];
            }
            return acc;
         }, {});
         return {
            action: apiMap[table],
            payload: payload,
         };
      }
      if (table === "driver") {
         const payload = DRIVER_FORM_FIELDS.reduce((acc, field) => {
            if (field in logData) {
               acc[field] = logData[field];
            }
            return acc;
         }, {});
         return {
            action: apiMap[table],
            payload: payload,
         };
      }
      if (table === "vehicle") {
         const payload = VEHICLE_FORM_FIELDS.reduce((acc, field) => {
            if (field in logData) {
               acc[field] = logData[field];
            }
            return acc;
         }, {});
         return {
            action: apiMap[table],
            payload: payload,
         };
      }
      if (table === "color") {
         const payload = COLOR_FORM_FIELDS.reduce((acc, field) => {
            if (field in logData) {
               acc[field] = logData[field];
            }
            return acc;
         }, {});
         return {
            action: apiMap[table],
            payload: payload,
         };
      }
      if (table === "style") {
         const payload = STYLE_FORM_FIELDS.reduce((acc, field) => {
            if (field in logData) {
               acc[field] = logData[field];
            }
            return acc;
         }, {});
         return {
            action: apiMap[table],
            payload: payload,
         };
      }
      if (table === "size") {
         const payload = SIZE_FORM_FIELDS.reduce((acc, field) => {
            if (field in logData) {
               acc[field] = logData[field];
            }
            return acc;
         }, {});
         return {
            action: apiMap[table],
            payload: payload,
         };
      }
      if (table === "area") {
         const payload = AREA_FORM_FIELDS.reduce((acc, field) => {
            if (field in logData) {
               acc[field] = logData[field];
            }
            return acc;
         }, {});
         return {
            action: apiMap[table],
            payload: payload,
         };
      }
      if (table === "brand") {
         const payload = BRAND_FORM_FIELDS.reduce((acc, field) => {
            if (field in logData) {
               acc[field] = logData[field];
            }
            return acc;
         }, {});
         return {
            action: apiMap[table],
            payload: payload,
         };
      }

      return {
         action: apiMap[table],
         payload: logData,
      };
   };

   // Function to restore deleted data
   const handleRestoreData = async () => {
      if (!logData || logData.entryType !== 'DELETE' || !logData.newJson) {
         toast({
            title: 'Cannot Restore',
            description: 'No deleted data available to restore.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         return;
      }

      const apiInfo = await getAPIAction(logData.tableName, logData.newJson);
      console.log('apiInfo', apiInfo.payload)

      if (!apiInfo || !apiInfo.action) {
         toast({
            title: 'API Not Found',
            description: `No API action found for table: ${logData.tableName}`,
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         return;
      }

      setIsRestoring(true);

      try {
         let payload;

         // Check if this is a transaction type that needs transformation
         const transactionTypes = ['purchases', 'purchasereturn', 'sales', 'salesreturn', 'issue', 'receive'];

         if (transactionTypes.includes(logData.tableName?.toLowerCase())) {
            // Use the transformed payload
            payload = await apiInfo.payload;
         }
         else if (logData.tableName?.toLowerCase() === "account") {
            payload = await apiInfo.payload;
            delete payload.id;
            delete payload.updatedAt;
            delete payload.companyIds;
         }
         else if (logData.tableName?.toLowerCase() === "item") {
            payload = await apiInfo.payload;
            delete payload.id;
            delete payload.updatedAt;
            delete payload.companyIds;
         }
         else if (logData.tableName?.toLowerCase() === "daybook") {
            payload = await apiInfo.payload;
            delete payload.isAbs;
            delete payload.sendEmail;
            delete payload.emailSettings;
            delete payload.allowZeroLineItems;
            delete payload.promptbeforecallosadj;
            delete payload.createdAt;
            delete payload.updatedAt;
            delete payload.createdBy;
            delete payload.updatedBy;
         }
         else if (logData.tableName?.toLowerCase() === "transport") {
            payload = await apiInfo.payload;
            delete payload.id;
            delete payload.updatedAt;
            delete payload.companyIds;
            delete payload.createdAt;
            delete payload.updatedAt;
            delete payload.createdBy;
            delete payload.updatedBy;
            delete payload.companyIds;
         }
         else if (logData.tableName?.toLowerCase() === "driver") {
            payload = await apiInfo.payload;
            delete payload.id;
            delete payload.updatedAt;
            delete payload.companyIds;
            delete payload.createdAt;
            delete payload.updatedAt;
            delete payload.createdBy;
            delete payload.updatedBy;
         }
         else if (logData.tableName?.toLowerCase() === "vehicle") {
            payload = await apiInfo.payload;
            delete payload.id;
            delete payload.updatedAt;
            delete payload.companyIds;
            delete payload.createdAt;
            delete payload.updatedAt;
            delete payload.createdBy;
            delete payload.updatedBy;
         }
         else if (logData.tableName?.toLowerCase() === "color") {
            payload = await apiInfo.payload;
            delete payload.id;
            delete payload.updatedAt;
            delete payload.companyIds;
            delete payload.createdAt;
            delete payload.updatedAt;
            delete payload.createdBy;
            delete payload.updatedBy;
         }
         else if (logData.tableName?.toLowerCase() === "style") {
            payload = await apiInfo.payload;
            delete payload.id;
            delete payload.updatedAt;
            delete payload.companyIds;
            delete payload.createdAt;
            delete payload.updatedAt;
            delete payload.createdBy;
            delete payload.updatedBy;
         }
         else if (logData.tableName?.toLowerCase() === "size") {
            payload = await apiInfo.payload;
            delete payload.id;
            delete payload.updatedAt;
            delete payload.companyIds;
            delete payload.createdAt;
            delete payload.updatedAt;
            delete payload.createdBy;
            delete payload.updatedBy;
         }
         else if (logData.tableName?.toLowerCase() === "area") {
            payload = await apiInfo.payload;
            delete payload.id;
            delete payload.updatedAt;
            delete payload.companyIds;
            delete payload.createdAt;
            delete payload.updatedAt;
            delete payload.createdBy;
            delete payload.updatedBy;
         }
         else if (logData.tableName?.toLowerCase() === "brand") {
            payload = await apiInfo.payload;
            delete payload.id;
            delete payload.updatedAt;
            delete payload.companyIds;
            delete payload.createdAt;
            delete payload.updatedAt;
            delete payload.createdBy;
            delete payload.updatedBy;
         }
         else if (logData.tableName?.toLowerCase() === "billterm") {
            payload = await apiInfo.payload;
            delete payload.id;
            delete payload.updatedAt;
            delete payload.companyIds;
            delete payload.createdAt;
            delete payload.updatedAt;
            delete payload.createdBy;
            delete payload.updatedBy;
         }
         else {
            // For non-transaction types (like voucher), use the original logic
            payload = { ...logData.newJson };
            if (logData.tableName?.toLowerCase() === 'item') {
               delete payload.hsn;
               delete payload.parentName;
               delete payload.uqc1Data;
               delete payload.uqc2Data;
               delete payload.uqc3Data;
               delete payload.vendorName;
            }
            if (logData.tableName?.toLowerCase() === 'transport') {
               delete payload.modeName;
            }
            if (logData.tableName?.toLowerCase() === 'driver') {
               delete payload.modeName;
            }

            if (logData.tableName?.toLowerCase() === 'area') {
               delete payload.city;
               delete payload.coid;
               delete payload.stid;
               delete payload.state;
               delete payload.country;
            }

            // Remove system fields that shouldn't be restored
            delete payload.id; // Let the system generate new ID
            delete payload.accountName;
            delete payload.daybookName;
            delete payload.bankBranchName;
            delete payload.bankName;
            delete payload.brokerName;
            delete payload.supplierName;
            delete payload.bankBranchName;
            delete payload.incomeId;
            delete payload.createdAt;
            delete payload.createdBy;
            delete payload.createdU;
            delete payload.createdu;
            delete payload.createdby;
            delete payload.updatedAt;
            delete payload.updatedBy;
            delete payload.updatedU;
            delete payload.updatedby;
            delete payload.updatedu;
            delete payload.status;
            delete payload.buffer;
         }
         if (transactionTypes.includes(logData.tableName?.toLowerCase())) {
            const res = await checkTransactionDocNo(
               logData.tableName?.toLowerCase(),
               payload?.header?.daybookId,
               payload?.header?.docno,
               payload?.header?.companyId,
            );

            if (res && res.code === 1 && res?.data?.isError) {
               Swal.fire({
                  title: res?.data?.message,
                  showCancelButton: true,
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No',
                  cancelButtonColor: '#d33',
                  confirmButtonColor: '#3085d6',
               }).then(async (swalResult) => {
                  if (swalResult.isConfirmed) {

                     const newPayload = { ...payload };
                     newPayload.header.docno = res.data?.newDocNo?.toString?.();

                     const dispatchResult = await dispatch(apiInfo.action(newPayload));

                     if (dispatchResult && dispatchResult?.code === 1) {
                        await dispatch(updateLogs({ id: logData?.id, isRestored: true }));
                        return;
                     }
                     if (dispatchResult && dispatchResult?.code === 2) {
                        console.log('result', dispatchResult?.message);
                        return;
                     }
                     return;
                  }
                  // return;
               });
            }
            else {
               const dispatchResult = await dispatch(apiInfo.action(payload));

               if (dispatchResult && dispatchResult?.code === 1) {
                  await dispatch(updateLogs({ id: logData?.id, isRestored: true }));
                  return;
               }
               if (dispatchResult && dispatchResult?.code === 2) {

                  return;
               }
               return;
            }
         }
         else if (logData.tableName?.toLowerCase() === 'voucher') {
            const financialYear = financialYears.find((a) => a.financial_year === user?.financialYear);

            const res = await dispatch(
               checkLastDocNumberVoucher({
                  companyId: payload.companyId,
                  daybookId: payload.daybookId,
                  txnType: payload.txnType,
                  type: payload.daybookType,
                  docNumber: payload.docNumber,
                  fromDate: moment(financialYear?.fy_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                  toDate: moment(financialYear?.fy_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
               }),
            );

            if (res && res.code === 1 && res?.data?.isError) {
               Swal.fire({
                  title: res?.data?.message,
                  showCancelButton: true,
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No',
                  cancelButtonColor: '#d33',
                  confirmButtonColor: '#3085d6',
               }).then(async (result) => {
                  if (result.isConfirmed) {
                     const newPayload = { ...payload };
                     newPayload.outAdjustments = newPayload?.outAdjustments?.map((oa) => {
                        return {
                           drDocHeaderId: oa.drDocHeaderId,
                           drDaybookId: oa.drDaybookId,
                           amount: oa.amount,
                           notes: oa.notes || '',
                        };
                     });
                     newPayload.docNumber = res.data?.newDocNo.toString();
                     delete newPayload.daybookType;
                     const result = await dispatch(apiInfo.action(newPayload));
                     if (result && !result.error) {
                        await dispatch(updateLogs({ id: logData?.id, isRestored: true }));
                     } else {
                        toast.error(result.error?.message || 'Restoration failed');
                     }
                  }
               });
            }

            const newPayload = { ...payload };
            newPayload.outAdjustments = newPayload?.outAdjustments?.map((oa) => {
               return {
                  drDocHeaderId: oa.drDocHeaderId,
                  drDaybookId: oa.drDaybookId,
                  amount: oa.amount,
                  notes: oa.notes || '',
               };
            });
            delete newPayload.daybookType;
            payload = newPayload;
         }
         else {
            // Dispatch the appropriate API action
            const result = await dispatch(apiInfo.action(payload));

            // Handle successful restoration
            if (result && !result.error) {
               await dispatch(updateLogs({ id: logData?.id, isRestored: true }));
            } else {
               toast.error(result.error?.message || 'Restoration failed');
            }
         }
      } catch (error) {
         console.error('Error restoring data:', error);
      } finally {
         setIsRestoring(false);
      }
   };

   // Handle modal close - clear selected log
   const handleClose = () => {
      onClose(); // This should call the parent's close handler that clears selectedLog
   };

   const formatValue = (value) => {
      if (value === null) return 'null';
      if (value === undefined) return 'undefined';
      if (typeof value === 'object') return JSON.stringify(value);
      return String(value);
   };

   const formatFieldName = (fieldName) => {
      // Handle line items
      const lineItemMatch = fieldName.match(/^lineitems?\[(\d+)\]\.(.+)$/i);
      if (lineItemMatch) {
         const itemNumber = parseInt(lineItemMatch[1]) + 1; // Convert 0-based to 1-based
         const subField = lineItemMatch[2];

         // Map technical field names to user-friendly names
         const fieldMappings = {
            hsnId: 'HSN Code',
            sacId: 'SAC Code',
            itemId: 'Item',
            itemRate: 'Rate',
            amount: 'Amount',
            netAmount: 'Net Amount',
            qty1: 'Quantity 1',
            qty2: 'Quantity 2',
            qty3: 'Quantity 3',
            taxableAmount: 'Taxable Amount',
            gstPercent: 'GST %',
            cgst: 'CGST',
            sgst: 'SGST',
            igst: 'IGST',
            warehouseId: 'Warehouse',
            typeOfSupply: 'Supply Type',
            ratePer: 'Rate Per',
            uomNoForRate: 'UOM',
            qUnitId1: 'Unit 1',
            qUnitId2: 'Unit 2',
            qUnitId3: 'Unit 3',
            addLess1Percent: 'Add/Less 1 %',
            addLess1Amount: 'Add/Less 1 Amount',
            addLess2Percent: 'Add/Less 2 %',
            addLess2Amount: 'Add/Less 2 Amount',
            addLess3Percent: 'Add/Less 3 %',
            addLess3Amount: 'Add/Less 3 Amount',
            netGst: 'Net GST',
            subHSNId: 'Sub HSN',
            // Additional fields from your data structure
            createdU: 'Created By',
            gstWithRate: 'GST with Rate',
            han: 'HAN',
            headerId: 'Header ID',
            id: 'Line Item ID',
            isClosed: 'Is Closed',
            itemName: 'Item Name',
            lineNumber: 'Line Number',
            sac: 'SAC',
            saleprice1: 'Sale Price 1',
            purchaseReturnLineDetail: 'Purchase Return Details',
            // HSN Data fields
            'hsnData.applyDate': 'HSN Apply Date',
            'hsnData.gstType': 'HSN GST Type',
            'hsnData.hsn': 'HSN Code',
            'hsnData.id': 'HSN ID',
            // SAC Data fields
            'sacData.applyDate': 'SAC Apply Date',
            'sacData.gstType': 'SAC GST Type',
            'sacData.hsn': 'SAC Code',
            'sacData.id': 'SAC ID',
         };

         // Handle nested HSN data fields
         if (subField.startsWith('hsnData.')) {
            const hsnField = subField.replace('hsnData.', '');
            const hsnFieldMappings = {
               applyDate: 'HSN Apply Date',
               gstType: 'HSN GST Type',
               hsn: 'HSN Code',
               id: 'HSN ID',
            };

            // Handle subHsn array
            const subHsnMatch = hsnField.match(/^subHsn\[(\d+)\]\.(.+)$/);
            if (subHsnMatch) {
               const subHsnIndex = parseInt(subHsnMatch[1]) + 1;
               const subHsnField = subHsnMatch[2];

               const subHsnFieldMappings = {
                  applyDate: 'Apply Date',
                  fromRate: 'From Rate',
                  gst: 'GST Rate',
                  id: 'Sub HSN ID',
                  taxGroup: 'Tax Group',
                  taxGroupId: 'Tax Group ID',
                  toRate: 'To Rate',
                  'ratio.cgst': 'CGST Ratio',
                  'ratio.igst': 'IGST Ratio',
                  'ratio.sgst': 'SGST Ratio',
                  'ratio.utgst': 'UTGST Ratio',
               };

               const friendlySubHsnField = subHsnFieldMappings[subHsnField] || subHsnField;
               return `Line Item ${itemNumber} - HSN Sub Item ${subHsnIndex} - ${friendlySubHsnField}`;
            }

            const friendlyHsnField = hsnFieldMappings[hsnField] || hsnField;
            return `Line Item ${itemNumber} - HSN - ${friendlyHsnField}`;
         }

         // Handle nested SAC data fields
         if (subField.startsWith('sacData.')) {
            const sacField = subField.replace('sacData.', '');
            const sacFieldMappings = {
               applyDate: 'SAC Apply Date',
               gstType: 'SAC GST Type',
               hsn: 'SAC Code',
               id: 'SAC ID',
            };

            const friendlySacField = sacFieldMappings[sacField] || sacField;
            return `Line Item ${itemNumber} - SAC - ${friendlySacField}`;
         }

         // Handle nested fields like stock details
         if (subField.includes('stock[')) {
            const stockMatch = subField.match(/^stock\[(\d+)\]\.(.+)$/);
            if (stockMatch) {
               const stockIndex = parseInt(stockMatch[1]) + 1;
               const stockField = stockMatch[2];

               const stockFieldMappings = {
                  serialNo: 'Serial Number',
                  serialNo2: 'Serial Number 2',
                  barcode: 'Barcode',
                  itemName: 'Item Name',
                  pcs: 'Pieces',
                  quantity1: 'Quantity',
                  isOld: 'Is Old',
                  warehouseId: 'Warehouse',
                  note1: 'Note',
               };

               const friendlyStockField = stockFieldMappings[stockField] || stockField;
               return `Line Item ${itemNumber} - Stock ${stockIndex} - ${friendlyStockField}`;
            }
         }

         // Handle purchase return line detail array
         if (subField.includes('purchaseReturnLineDetail[')) {
            const returnMatch = subField.match(/^purchaseReturnLineDetail\[(\d+)\]\.(.+)$/);
            if (returnMatch) {
               const returnIndex = parseInt(returnMatch[1]) + 1;
               const returnField = returnMatch[2];
               return `Line Item ${itemNumber} - Return Detail ${returnIndex} - ${returnField}`;
            }
         }

         const friendlySubField = fieldMappings[subField] || subField;
         return `Line Item ${itemNumber} - ${friendlySubField}`;
      }

      // Handle header fields
      const headerFieldMappings = {
         daybookId: 'Daybook',
         docno: 'Document Number',
         transactionAt: 'Transaction Date',
         companyId: 'Company',
         accountId: 'Account',
         brokerId: 'Broker',
         basicAmount: 'Basic Amount',
         additionAmount: 'Addition Amount',
         deductionAmount: 'Deduction Amount',
         netAmount: 'Net Amount',
         dueDays: 'Due Days',
         dueAt: 'Due Date',
         billtoStateId: 'Bill To State',
         shiptoStateId: 'Ship To State',
         warehouseId: 'Warehouse',
         partyNo: 'Party Number',
         partyDate: 'Party Date',
         notes: 'Notes',
         representativeId: 'Representative',
         voucherId: 'Voucher',
         gstAmount: 'GST Amount',
         taxableAmount: 'Taxable Amount',
         gstTxnType: 'GST Transaction Type',
         gstSubTxnType: 'GST Sub Transaction Type',
         assesseType: 'Assesse Type',
         distance: 'Distance',
         originalBillDate: 'Original Bill Date',
         originalBillNo: 'Original Bill Number',
         issueType: 'Issue Type',
         requestedBy: 'Requested By',
         receiptType: 'Receipt Type',
         receivedFrom: 'Received From',
      };

      // Handle vouchers array
      const voucherMatch = fieldName.match(/^vouchers?\[(\d+)\]\.(.+)$/i);
      if (voucherMatch) {
         const voucherNumber = parseInt(voucherMatch[1]) + 1;
         const voucherField = voucherMatch[2];

         const voucherFieldMappings = {
            amount: 'Amount',
            accountId: 'Account',
            notes: 'Notes',
            voucherType: 'Voucher Type',
            referenceNo: 'Reference Number',
            referenceDate: 'Reference Date',
         };

         const friendlyVoucherField = voucherFieldMappings[voucherField] || voucherField;
         return `Payment ${voucherNumber} - ${friendlyVoucherField}`;
      }

      // Handle bill terms
      const billTermMatch = fieldName.match(/^(sale|purchase|issue|receipt)BillTerms\[(\d+)\]\.(.+)$/i);
      if (billTermMatch) {
         const termType = billTermMatch[1];
         const termNumber = parseInt(billTermMatch[2]) + 1;
         const termField = billTermMatch[3];

         const termFieldMappings = {
            billTermId: 'Term ID',
            percentage: 'Percentage',
            amount: 'Amount',
         };

         const friendlyTermField = termFieldMappings[termField] || termField;
         return `${termType.charAt(0).toUpperCase() + termType.slice(1)} Term ${termNumber} - ${friendlyTermField}`;
      }

      // Handle other array fields generically
      const arrayMatch = fieldName.match(/^(.+)\[(\d+)\]\.(.+)$/);
      if (arrayMatch) {
         const arrayName = arrayMatch[1];
         const index = parseInt(arrayMatch[2]) + 1;
         const subField = arrayMatch[3];

         return `${arrayName.charAt(0).toUpperCase() + arrayName.slice(1)} ${index} - ${subField}`;
      }

      // Handle simple array indices
      const simpleArrayMatch = fieldName.match(/^(.+)\[(\d+)\]$/);
      if (simpleArrayMatch) {
         const arrayName = simpleArrayMatch[1];
         const index = parseInt(simpleArrayMatch[2]) + 1;

         return `${arrayName.charAt(0).toUpperCase() + arrayName.slice(1)} ${index}`;
      }

      // Return mapped header field or original field name
      return headerFieldMappings[fieldName] || fieldName;
   };

   const compareObjects = (oldObj, newObj, path = '') => {
      const differences = [];

      // Handle case where oldObj is null (ADD operation)
      if (oldObj === null || oldObj === undefined) {
         if (newObj && typeof newObj === 'object') {
            // For ADD operations, show all fields as "added"
            const processObject = (obj, currentPath) => {
               Object.keys(obj).forEach((key) => {
                  const fieldPath = currentPath ? `${currentPath}.${key}` : key;
                  const value = obj[key];

                  if (Array.isArray(value)) {
                     value.forEach((item, index) => {
                        if (typeof item === 'object' && item !== null) {
                           processObject(item, `${fieldPath}[${index}]`);
                        } else {
                           differences.push({
                              field: `${fieldPath}[${index}]`,
                              oldValue: 'N/A',
                              newValue: item,
                              type: 'added',
                           });
                        }
                     });
                  } else if (typeof value === 'object' && value !== null) {
                     processObject(value, fieldPath);
                  } else {
                     differences.push({
                        field: fieldPath,
                        oldValue: 'N/A',
                        newValue: value,
                        type: 'added',
                     });
                  }
               });
            };

            processObject(newObj, path);
            return differences;
         }
      }

      // Handle case where newObj is null (DELETE operation)
      if (newObj === null || newObj === undefined) {
         if (oldObj && typeof oldObj === 'object') {
            const processObject = (obj, currentPath) => {
               Object.keys(obj).forEach((key) => {
                  const fieldPath = currentPath ? `${currentPath}.${key}` : key;
                  const value = obj[key];

                  if (Array.isArray(value)) {
                     value.forEach((item, index) => {
                        if (typeof item === 'object' && item !== null) {
                           processObject(item, `${fieldPath}[${index}]`);
                        } else {
                           differences.push({
                              field: `${fieldPath}[${index}]`,
                              oldValue: item,
                              newValue: 'N/A',
                              type: 'removed',
                           });
                        }
                     });
                  } else if (typeof value === 'object' && value !== null) {
                     processObject(value, fieldPath);
                  } else {
                     differences.push({
                        field: fieldPath,
                        oldValue: value,
                        newValue: 'N/A',
                        type: 'removed',
                     });
                  }
               });
            };

            processObject(oldObj, path);
            return differences;
         }
      }

      // Normal comparison for UPDATE operations
      const allKeys = new Set([...Object.keys(oldObj || {}), ...Object.keys(newObj || {})]);

      for (const key of allKeys) {
         const currentPath = path ? `${path}.${key}` : key;
         const oldValue = oldObj?.[key];
         const newValue = newObj?.[key];

         if (oldValue === null && newValue === null) continue;
         if (oldValue === undefined && newValue === undefined) continue;

         if (Array.isArray(oldValue) && Array.isArray(newValue)) {
            // Handle arrays
            const maxLength = Math.max(oldValue.length, newValue.length);
            for (let i = 0; i < maxLength; i++) {
               if (typeof oldValue[i] === 'object' && typeof newValue[i] === 'object') {
                  differences.push(...compareObjects(oldValue[i], newValue[i], `${currentPath}[${i}]`));
               } else if (oldValue[i] !== newValue[i]) {
                  differences.push({
                     field: `${currentPath}[${i}]`,
                     oldValue: oldValue[i] ?? 'N/A',
                     newValue: newValue[i] ?? 'N/A',
                     type: 'modified',
                  });
               }
            }
         } else if (typeof oldValue === 'object' && typeof newValue === 'object') {
            // Handle nested objects
            differences.push(...compareObjects(oldValue, newValue, currentPath));
         } else if (oldValue !== newValue) {
            // Handle primitive values
            differences.push({
               field: currentPath,
               oldValue: oldValue ?? 'N/A',
               newValue: newValue ?? 'N/A',
               type: oldValue === undefined ? 'added' : newValue === undefined ? 'removed' : 'modified',
            });
         }
      }

      return differences;
   };

   const differences = useMemo(() => {
      if (!logData || (!logData.oldJson && !logData.newJson)) {
         return [];
      }
      const removeBufferData = (json) => {
         if (!json) return null;
         const cloned = { ...json };
         delete cloned.buffer;
         return cloned;
      };

      let rawDifferences = [];

      // Handle different entry types
      switch (logData.entryType) {
         case 'ADD':
            rawDifferences = compareObjects(
               null,
               removeBufferData(logData.newJson)
                  ? removeBufferData(logData.newJson)
                  : removeBufferData(logData.newJson)?.body,
            );
            break;
         case 'DELETE':
            rawDifferences = compareObjects(
               removeBufferData(logData.newJson)
                  ? removeBufferData(logData.newJson)
                  : removeBufferData(logData.newJson)?.body,
               null,
            );
            break;
         case 'UPDATE':
         default:
            rawDifferences = compareObjects(
               removeBufferData(logData.oldJson)
                  ? removeBufferData(logData.oldJson)
                  : removeBufferData(logData.oldJson)?.body,
               removeBufferData(logData.newJson)
                  ? removeBufferData(logData.newJson)
                  : removeBufferData(logData.newJson)?.body,
            );
            break;
      }

      // Define specific ID fields to exclude (manual exclusion)
      const idFieldsToExclude = [
         'id',
         '_id',
         'ID',
         '_ID',
         'userId',
         'productId',
         'orderId',
         'UserId',
         'ProductId',
         'OrderId',
         'companyId',
         'accountId',
         'brokerId',
         'daybookId',
         'warehouseId',
         'representativeId',
         'voucherId',
         'itemId',
         'hsnId',
         'sacId',
         'subHSNId',
         'billtoStateId',
         'shiptoStateId',
         'qUnitId1',
         'qUnitId2',
         'qUnitId3',
         'issueLineId',
         'pinvLineDetailId',
         'outAdjustmentId',
         'updatedU',
      ];

      // Filter and format differences
      return rawDifferences
         .filter((diff) => {
            // Remove entries with N/A old value and null new value
            if (diff.oldValue === 'N/A' && diff.newValue === null) {
               return false;
            }

            const originalFieldName = diff.field;
            const fieldName = originalFieldName.toLowerCase();

            // Manual exclusion: Remove specific ID fields from the predefined list
            if (
               idFieldsToExclude.includes(originalFieldName) ||
               idFieldsToExclude.map((f) => f.toLowerCase()).includes(fieldName)
            ) {
               return false;
            }

            // Automatic exclusion: Remove all ID fields (case-insensitive check for various ID field patterns)
            if (
               fieldName === 'id' ||
               fieldName === '_id' ||
               fieldName.endsWith('id') ||
               fieldName.endsWith('_id') ||
               fieldName.includes('id_') ||
               fieldName.startsWith('id') ||
               /^.*id$/i.test(originalFieldName) ||
               /^id.*$/i.test(originalFieldName) ||
               /^.*_id$/i.test(originalFieldName)
            ) {
               return false;
            }

            return true;
         })
         .map((diff) => ({
            ...diff,
            field: formatFieldName(diff.field), // Convert technical field name to user-friendly name
            originalField: diff.field, // Keep original field name for reference if needed
         }));
   }, [logData]);

   const openLocationInMaps = () => {
      const deviceData = logData?.deviceData;
      if ((deviceData?.latitude && deviceData?.longitude) || (deviceData?.lat && deviceData?.long)) {
         const lat = deviceData.latitude || deviceData.lat;
         const lng = deviceData.longitude || deviceData.long;
         const url = `https://www.google.com/maps?q=${lat},${lng}`;
         window.open(url, '_blank');
      } else {
         alert('Location data not available');
      }
   };

   const formatDeviceValue = (value) => {
      if (value === null || value === undefined) return 'N/A';
      if (typeof value === 'string' && value.startsWith('[') && value.endsWith(']')) {
         try {
            const parsed = JSON.parse(value);
            return JSON.stringify(parsed, null, 2);
         } catch (e) {
            return value;
         }
      }
      return String(value);
   };

   const getDeviceDisplayName = (key) => {
      const displayNames = {
         url: 'Request URL',
         method: 'HTTP Method',
         publicIp: 'Public IP Address',
         userAgent: 'User Agent',
         currentUrl: 'Current Page URL',
         deviceOsName: 'Operating System',
         deviceBrowser: 'Browser',
         browserPlugins: 'Browser Plugins',
         deviceLanguage: 'Language',
         devicePlatform: 'Platform',
         deviceTimezone: 'Timezone',
         deviceUserAgent: 'Device User Agent',
         devicePixelRatio: 'Pixel Ratio',
         requestTimestamp: 'Request Time',
         storageIndexedDb: 'IndexedDB Support',
         deviceScreenWidth: 'Screen Width',
         deviceOnlineStatus: 'Online Status',
         deviceScreenHeight: 'Screen Height',
         deviceCookieEnabled: 'Cookies Enabled',
         storageLocalStorage: 'Local Storage',
         deviceMaxTouchPoints: 'Max Touch Points',
         storageSessionStorage: 'Session Storage',
         deviceHardwareConcurrency: 'CPU Cores',
         latitude: 'Latitude',
         longitude: 'Longitude',
      };
      return displayNames[key] || key;
   };

   const getChangeTypeColor = (type) => {
      switch (type) {
         case 'added':
            return 'green';
         case 'removed':
            return 'red';
         case 'modified':
            return 'blue';
         default:
            return 'gray';
      }
   };

   const getEntryTypeMessage = () => {
      switch (logData?.entryType) {
         case 'ADD':
            return 'All fields shown below were added in this creation operation.';
         case 'DELETE':
            return 'All fields shown below were removed in this deletion operation.';
         case 'UPDATE':
            return `changes detected in this update operation.`;
         default:
            return `changes detected in this ${logData?.entryType?.toLowerCase()} operation.`;
      }
   };

   if (!logData) {
      return null;
   }

   const JsonViewer = ({ payload }) => {
      const toast = useToast();

      const handleCopy = () => {
         navigator.clipboard.writeText(JSON.stringify(payload, null, 2));
         toast({
            title: 'Copied!',
            description: 'Full JSON copied to clipboard',
            status: 'success',
            duration: 2000,
            isClosable: true,
         });
      };

      return (
         <Box border="1px solid" borderColor="gray.300" borderRadius="md" p={4} bg="gray.50">
            <Box display="flex" justifyContent="flex-end" mb={2}>
               <Button size="sm" leftIcon={<CopyIcon />} onClick={handleCopy}>
                  Copy JSON
               </Button>
            </Box>
            <Code display="block" whiteSpace="pre" overflowX="auto" fontSize="sm" p={2} w="100%">
               {JSON.stringify(payload, null, 2)}
            </Code>
         </Box>
      );
   };

   return (
      <Modal isOpen={isOpen} onClose={handleClose} size="6xl" scrollBehavior="inside">
         <ModalOverlay />
         <ModalContent maxH="90vh">
            <ModalHeader>
               <VStack align="start" spacing={1}>
                  <HStack justify="space-between" width="100%">
                     <Text fontSize="xl" fontWeight="semibold">
                        Change History - {logData.tableName}
                     </Text>

                     {/* <Button onClick={handleAccessCodeModalOpen}>Developers Section</Button> */}

                     {/* Restore Button - Only show for DELETE operations */}
                     {logData.entryType === 'DELETE' && logData.newJson && (
                        <Button
                           leftIcon={isRestoring ? <Spinner size="sm" /> : <RepeatIcon />}
                           colorScheme="green"
                           variant="solid"
                           size="sm"
                           mr="7"
                           onClick={handleRestoreData}
                           isLoading={isRestoring}
                           loadingText="Restoring..."
                           isDisabled={isRestoring}>
                           Restore Data
                        </Button>
                     )}
                  </HStack>

                  <HStack spacing={4}>
                     <Text fontSize="sm" color="gray.600">
                        Entry Type:{' '}
                        <Text
                           as="span"
                           fontWeight="medium"
                           color={
                              logData.entryType === 'ADD'
                                 ? 'green.600'
                                 : logData.entryType === 'DELETE'
                                    ? 'red.600'
                                    : logData.entryType === 'UPDATE'
                                       ? 'blue.600'
                                       : 'gray.600'
                           }>
                           {logData.entryType}
                        </Text>
                     </Text>
                     <Text fontSize="sm" color="gray.600">
                        Created At: {new Date(logData.createdAt).toLocaleString()}
                     </Text>
                     <Text fontSize="sm" color="gray.600">
                        By: {logData.createdby || `User ${logData.createdBy}`}
                     </Text>
                     <Button
                        size="sm"
                        leftIcon={<FaLock />}
                        colorScheme="blue"
                        variant="outline"
                        onClick={handleAccessCodeModalOpen}>
                        Developers Section
                     </Button>
                     {logData.deviceData && (
                        <Button
                           size="sm"
                           leftIcon={<InfoIcon />}
                           colorScheme="blue"
                           variant="outline"
                           onClick={onDeviceModalOpen}>
                           Device Info
                        </Button>
                     )}
                  </HStack>
               </VStack>
            </ModalHeader>
            <ModalCloseButton />

            <ModalBody pb={6}>
               {/* Show restore confirmation for DELETE operations */}
               {logData.entryType === 'DELETE' && (
                  <Alert status="warning" variant="left-accent" mb={4}>
                     <AlertIcon />
                     <Box>
                        <Text fontSize="sm" fontWeight="semibold">
                           Deleted Data Recovery Available
                        </Text>
                        <Text fontSize="xs" color="gray.600">
                           This data was deleted and can be restored using the "Restore Data" button above.
                        </Text>
                     </Box>
                  </Alert>
               )}

               {differences.length === 0 ? (
                  <Box textAlign="center" py={8}>
                     <Text color="gray.500">No changes detected between old and new data.</Text>
                  </Box>
               ) : (
                  <VStack spacing={6} align="stretch">
                     <Alert
                        status={
                           logData.entryType === 'ADD' ? 'success' : logData.entryType === 'DELETE' ? 'error' : 'info'
                        }
                        variant="left-accent">
                        <AlertIcon />
                        <Text fontSize="sm">
                           <Text as="span" fontWeight="bold">
                              {differences.length}
                           </Text>{' '}
                           {getEntryTypeMessage()}
                        </Text>
                     </Alert>

                     <Box borderWidth={1} borderRadius="md" overflow="hidden">
                        <Box overflowX="auto">
                           <Table variant="simple" size="sm">
                              <Thead bg="gray.100">
                                 <Tr>
                                    <Th
                                       fontSize="xs"
                                       textTransform="uppercase"
                                       letterSpacing="wider"
                                       width="25%"
                                       border="1px solid"
                                       borderColor="black">
                                       Field
                                    </Th>
                                    <Th
                                       fontSize="xs"
                                       textTransform="uppercase"
                                       letterSpacing="wider"
                                       width="30%"
                                       border="1px solid"
                                       borderColor="black">
                                       Old Data
                                    </Th>
                                    <Th
                                       fontSize="xs"
                                       textTransform="uppercase"
                                       letterSpacing="wider"
                                       width="30%"
                                       border="1px solid"
                                       borderColor="black">
                                       New Data
                                    </Th>
                                    <Th
                                       fontSize="xs"
                                       textTransform="uppercase"
                                       letterSpacing="wider"
                                       width="15%"
                                       border="1px solid"
                                       borderColor="black">
                                       Change Type
                                    </Th>
                                 </Tr>
                              </Thead>
                              <Tbody>
                                 {differences.map((diff, index) => (
                                    <Tr key={index} _hover={{ bg: 'gray.50' }}>
                                       <Td border="1px solid" borderColor="black">
                                          <Code fontSize="sm" fontFamily="mono">
                                             {diff.field}
                                          </Code>
                                       </Td>
                                       <Td border="1px solid" borderColor="black">
                                          <Code
                                             bg={diff.type === 'removed' ? 'red.50' : 'gray.100'}
                                             p={2}
                                             borderRadius="sm"
                                             fontSize="xs"
                                             color={diff.type === 'removed' ? 'red.600' : 'inherit'}
                                             display="block"
                                             whiteSpace="pre-wrap"
                                             wordBreak="break-all">
                                             {formatValue(diff.oldValue)}
                                          </Code>
                                       </Td>
                                       <Td border="1px solid" borderColor="black">
                                          <Code
                                             bg={diff.type === 'added' ? 'green.50' : 'gray.100'}
                                             p={2}
                                             borderRadius="sm"
                                             fontSize="xs"
                                             color={diff.type === 'added' ? 'green.600' : 'inherit'}
                                             display="block"
                                             whiteSpace="pre-wrap"
                                             wordBreak="break-all">
                                             {formatValue(diff.newValue)}
                                          </Code>
                                       </Td>
                                       <Td border="1px solid" borderColor="black">
                                          <Badge
                                             colorScheme={getChangeTypeColor(diff.type)}
                                             variant="subtle"
                                             fontSize="xs">
                                             {diff.type}
                                          </Badge>
                                       </Td>
                                    </Tr>
                                 ))}
                              </Tbody>
                           </Table>
                        </Box>
                     </Box>
                  </VStack>
               )}
            </ModalBody>
            {/* Device Information Modal */}
            <Modal isOpen={isDeviceModalOpen} onClose={onDeviceModalClose} size="4xl" scrollBehavior="inside">
               <ModalOverlay />
               <ModalContent maxH="90vh" display="flex" flexDirection="column">
                  <ModalHeader flexShrink={0}>
                     <HStack justify="space-between" align="center">
                        <Text fontSize="xl" fontWeight="semibold">
                           Device Information
                        </Text>
                        {(logData?.deviceData?.latitude && logData?.deviceData?.longitude) ||
                           logData?.deviceData?.publicIp ? (
                           <Button
                              size="sm"
                              leftIcon={<ExternalLinkIcon />}
                              colorScheme="green"
                              variant="outline"
                              mr={5}
                              onClick={openLocationInMaps}>
                              View Location
                           </Button>
                        ) : null}
                     </HStack>
                  </ModalHeader>
                  <ModalCloseButton />

                  <ModalBody pb={6} flex="1" overflowY="auto">
                     {logData?.deviceData ? (
                        <Box>
                           <Alert status="info" variant="left-accent" mb={4}>
                              <AlertIcon />
                              <Text fontSize="sm">
                                 Device and browser information captured at the time of this operation.
                              </Text>
                           </Alert>

                           <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                              {Object.entries(logData.deviceData).map(([key, value]) => (
                                 <GridItem
                                    key={key}
                                    colSpan={
                                       key === 'browserPlugins' || key === 'userAgent' || key === 'deviceUserAgent'
                                          ? 2
                                          : 1
                                    }>
                                    <Box p={3} borderWidth={1} borderRadius="md" bg="gray.50">
                                       <Text fontSize="sm" fontWeight="semibold" color="gray.700" mb={1}>
                                          {getDeviceDisplayName(key)}
                                       </Text>
                                       <Code
                                          p={2}
                                          borderRadius="sm"
                                          fontSize="xs"
                                          display="block"
                                          whiteSpace="pre-wrap"
                                          wordBreak="break-all"
                                          bg="white">
                                          {formatDeviceValue(value)}
                                       </Code>
                                    </Box>
                                 </GridItem>
                              ))}
                           </Grid>
                        </Box>
                     ) : (
                        <Box textAlign="center" py={8}>
                           <Text color="gray.500">No device information available.</Text>
                        </Box>
                     )}
                  </ModalBody>
               </ModalContent>
            </Modal>
            <Modal isOpen={isAccessCodeModalOpen} onClose={onAccessCodeModalClose} size="md">
               <ModalOverlay />
               <ModalContent>
                  <ModalHeader>
                     <Text fontSize="xl" fontWeight="semibold">
                        Developers Section
                     </Text>
                  </ModalHeader>
                  <ModalCloseButton />

                  <ModalBody pb={6}>
                     <FormControl>
                        <FormLabel fontSize="sm" fontWeight="medium">
                           Developers Section Code
                        </FormLabel>
                        <Input
                           type="password"
                           placeholder="Enter access code..."
                           value={tempAccessCode}
                           onChange={(e) => setTempAccessCode(e.target.value)}
                           onKeyPress={(e) => {
                              if (e.key === 'Enter') {
                                 handleSetAccessCode();
                              }
                           }}
                        />
                     </FormControl>
                  </ModalBody>

                  <ModalFooter>
                     <Button variant="outline" mr={3} onClick={onAccessCodeModalClose}>
                        Cancel
                     </Button>
                     <Button
                        colorScheme="blue"
                        onClick={handleSetAccessCode}
                        isLoading={isLoadingLogData}
                        loadingText="Fetching..."
                        isDisabled={isLoadingLogData}>
                        Fetch Log Data
                     </Button>
                  </ModalFooter>
               </ModalContent>
            </Modal>
            <Modal isOpen={isOpenPayload} onClose={onClosePayload} size="4xl" overflow="scroll">
               <ModalOverlay />
               <ModalContent>
                  <ModalHeader>
                     <Text fontSize="xl" fontWeight="semibold">
                        Playload
                     </Text>
                  </ModalHeader>
                  <ModalCloseButton />

                  <ModalBody pb={6}>
                     <Box borderWidth={1} borderRadius="md" overflow="hidden">
                        <Box overflowX="auto">
                           <Table variant="simple" size="sm">
                              <Thead bg="gray.100">
                                 <Tr>
                                    <Th
                                       fontSize="xs"
                                       textTransform="uppercase"
                                       letterSpacing="wider"
                                       width="10%"
                                       border="1px solid"
                                       borderColor="black">
                                       Data
                                    </Th>
                                 </Tr>
                              </Thead>
                              <Tbody>
                                 <JsonViewer payload={logData.payload} />
                                 {/* {logData.payload.map((diff, index) => (
                                    <Tr key={index} _hover={{ bg: 'gray.50' }}>
                                       <Td border="1px solid" borderColor="black">
                                          <Code fontSize="sm" fontFamily="mono">
                                             {diff.field}
                                          </Code>
                                       </Td>
                                       <Td border="1px solid" borderColor="black">
                                          <Code
                                             bg={diff.type === 'added' ? 'green.50' : 'gray.100'}
                                             p={2}
                                             borderRadius="sm"
                                             fontSize="xs"
                                             color={diff.type === 'added' ? 'green.600' : 'inherit'}
                                             display="block"
                                             whiteSpace="pre-wrap"
                                             wordBreak="break-all">
                                             {formatValue(diff.newValue)}
                                          </Code>
                                       </Td>
                                    </Tr>
                                 ))} */}
                              </Tbody>
                           </Table>
                        </Box>
                     </Box>
                  </ModalBody>

                  <ModalFooter>
                     <Button variant="outline" mr={3} onClick={onAccessCodeModalClose}>
                        Cancel
                     </Button>
                     <Button
                        colorScheme="blue"
                        onClick={handleSetAccessCode}
                        isLoading={isLoadingLogData}
                        loadingText="Fetching..."
                        isDisabled={isLoadingLogData}>
                        Fetch Log Data
                     </Button>
                  </ModalFooter>
               </ModalContent>
            </Modal>
         </ModalContent>
      </Modal>
   );
};

export default JsonDifferenceModal;
